import { render } from "./Team.vue?vue&type=template&id=c8803fe6&scoped=true"
import script from "./Team.vue?vue&type=script&lang=js"
export * from "./Team.vue?vue&type=script&lang=js"

import "./Team.vue?vue&type=style&index=0&id=c8803fe6&scoped=true&lang=css"
import "./Team.vue?vue&type=style&index=1&id=c8803fe6&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8803fe6"]])

export default __exports__